// extracted by mini-css-extract-plugin
module.exports = {"textPrimary":"var(--color-text-primary)","container":"Layout_container__JuY_k","redesignText":"Layout_redesignText__s9WXe"};